import React from 'react'
import { createRoot } from 'react-dom/client'

// import MonitoreoDatosVarsMapa from './pages/monitoreoDatosVarsMapa'
// import MonDVMap2 from './pages/datos_vars/monDVMap2'
// import PronosticoMarino from './pages/pronostico-marino/pronosMarino'
import GeoVisualizador from './pages/geo-visualizador/geoVisualizador'
//import GeoVisualizadorV2 from './pages/geo-visualizador/geoVisualizadorV2'
//import MonitoreoDatosVarsGraficas from "./pages/monitoreoDatosVarsGraficas";
//import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Highcharts from 'highcharts'

// css
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css'
import './scss/react.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

Highcharts.setOptions({
    lang: {
        loading: 'Cargando...',
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
        weekdays: [
            'Domingo',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado',
        ],
        shortMonths: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
        ],
        exportButtonTitle: 'Exportar',
        printButtonTitle: 'Importar',
        rangeSelectorFrom: 'Desde',
        rangeSelectorTo: 'Hasta',
        rangeSelectorZoom: 'Período',
        downloadPNG: 'Descargar imagen PNG',
        downloadJPEG: 'Descargar imagen JPEG',
        downloadPDF: 'Descargar imagen PDF',
        downloadSVG: 'Descargar imagen SVG',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        thousandsSep: ',',
        decimalPoint: '.',
    },
})
/*
const App = function () {
    return <PronosticoMarino />
}
*/

const App = function () {
    return <GeoVisualizador />
}

/*const App = function () {
    return <MonitoreoDatosVarsMapa />
}*/
/*
const App = function () {
    return <MonDVMap2 />
}
*/
/*

        <BrowserRouter>
            <Routes>
                <Route path="/">
                    <Route
                        key="1"
                        path="reportes/pages/custom/datos24hv2"
                        element={<MonitoreoDatosVarsMapa />}
                    />
                    <Route
                        key="2"
                        path="/"
                        element={<PronosticoMarino />}
                    />
                </Route>
            </Routes>
        </BrowserRouter>


*/

const root = createRoot(document.getElementById('root'))
root.render(<App />)
